import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type DirectionsCarProps = IconComponentBaseProps;

export const DirectionsCar = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: DirectionsCarProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_10256_35862"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10256_35862)">
        <path
          d="M5.61525 18.5V19.4423C5.61525 19.7361 5.51233 19.9858 5.3065 20.1915C5.10067 20.3972 4.85067 20.5 4.5565 20.5C4.2625 20.5 4.01292 20.3972 3.80775 20.1915C3.60258 19.9858 3.5 19.7361 3.5 19.4423V12.3885C3.5 12.2847 3.50675 12.1808 3.52025 12.077C3.53375 11.9732 3.55642 11.8737 3.58825 11.7785L5.379 6.7155C5.49883 6.35533 5.716 6.06275 6.0305 5.83775C6.345 5.61258 6.697 5.5 7.0865 5.5H16.9135C17.303 5.5 17.655 5.61258 17.9695 5.83775C18.284 6.06275 18.5012 6.35533 18.621 6.7155L20.4117 11.7785C20.4436 11.8737 20.4662 11.9732 20.4797 12.077C20.4932 12.1808 20.5 12.2847 20.5 12.3885V19.4423C20.5 19.7361 20.3971 19.9858 20.1913 20.1915C19.9853 20.3972 19.7353 20.5 19.4413 20.5C19.1471 20.5 18.8974 20.3972 18.6923 20.1915C18.4873 19.9858 18.3848 19.7361 18.3848 19.4423V18.5H5.61525ZM5.60775 10.577H18.3923L17.2078 7.202C17.1821 7.13783 17.1436 7.08817 17.0922 7.053C17.0409 7.01767 16.98 7 16.9095 7H7.0905C7.02 7 6.95908 7.01767 6.90775 7.053C6.85642 7.08817 6.81792 7.13783 6.79225 7.202L5.60775 10.577ZM7.46375 15.8463C7.82758 15.8463 8.13617 15.7188 8.3895 15.464C8.64267 15.2093 8.76925 14.9001 8.76925 14.5363C8.76925 14.1724 8.64192 13.8638 8.38725 13.6105C8.13242 13.3573 7.82308 13.2308 7.45925 13.2308C7.09542 13.2308 6.78692 13.3581 6.53375 13.6128C6.28042 13.8676 6.15375 14.1769 6.15375 14.5408C6.15375 14.9046 6.28117 15.2131 6.536 15.4663C6.79067 15.7196 7.09992 15.8463 7.46375 15.8463ZM16.5408 15.8463C16.9046 15.8463 17.2131 15.7188 17.4663 15.464C17.7196 15.2093 17.8462 14.9001 17.8462 14.5363C17.8462 14.1724 17.7188 13.8638 17.464 13.6105C17.2093 13.3573 16.9001 13.2308 16.5363 13.2308C16.1724 13.2308 15.8638 13.3581 15.6105 13.6128C15.3573 13.8676 15.2308 14.1769 15.2308 14.5408C15.2308 14.9046 15.3581 15.2131 15.6128 15.4663C15.8676 15.7196 16.1769 15.8463 16.5408 15.8463ZM5 17H19V12.077H5V17Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
